import { render, staticRenderFns } from "./Companies.vue?vue&type=template&id=1a761768&scoped=true"
import script from "./Companies.vue?vue&type=script&lang=ts"
export * from "./Companies.vue?vue&type=script&lang=ts"
import style0 from "./Companies.vue?vue&type=style&index=0&id=1a761768&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a761768",
  null
  
)

export default component.exports